export default __webpack_public_path__ + "static/media/howwork1.723d55e2.svg";